import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-info-dialog',
  template: `
    <div class="flex items-center mb-1" mat-dialog-title>
      <p class="flex-auto text-lg font-medium">{{data.title}}</p>
    </div>

    <mat-dialog-content>
      <p>{{data.info}}</p>
    </mat-dialog-content>

    <mat-dialog-actions>
      <span class="flex-1"></span>
      <button mat-dialog-close color="primary" mat-flat-button type="button">
        <span>OK</span>
      </button>
    </mat-dialog-actions>`,
  styles: [
  ]
})
export class InfoDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (!this.data.title) { this.data.title = 'Info'; }
  }

}
